import { DateTime } from "luxon";
import { ProcessViewModel } from "../../../models/Process";
import { processStatus } from "../../Configurations/tabs/types";
import { incotermOptions } from "../../../utils/incoterms";
import { HStack } from "@chakra-ui/react";
import ProcessUrgencyBadge from "../../../components/ProcessUrgencyBadge";
import React from "react";
import { formatSince } from "../../../utils/duration";

export const columns = [
  {
    label: "CVF Ref",
    sortable: true,
    fixed: true,
    data: (p: ProcessViewModel) => React.createElement(
      HStack,
      { spacing: "8px" },
      React.createElement("span", null, p.cvfRef),
      p.isUrgent ? React.createElement(ProcessUrgencyBadge, { compact: true }) : null,
    ),
    index: "cvfRef",
  },
  {
    label: "Número Ref.",
    sortable: true,
    data: (p: ProcessViewModel) => p.clientRef,
    index: "clientRef",
    editable: true,
    type: "text" as const,
  },
  {
    label: "Responsável",
    sortable: true,
    data: (p: ProcessViewModel) => p.responsibleName,
    index: "responsibleName",
    editable: false,
    type: "text" as const,
  },
  {
    label: "Cliente",
    sortable: true,
    data: (p: ProcessViewModel) => p.clientName,
    index: "clientName",
  },
  {
    label: "Aparece pro cliente",
    sortable: true,
    data: (p: ProcessViewModel) => p.refName,
    index: "refName",
  },
  {
    label: "Despachante",
    sortable: true,
    data: (p: ProcessViewModel) => p.dispatcher,
    index: "dispatcher",
    editable: true,
    type: "text" as const,
  },
  {
    label: "Status",
    sortable: true,
    data: (p: ProcessViewModel) => p.status,
    index: "status",
    editable: true,
    type: "select" as const,
    options: processStatus,
    width: "150px",
  },
  {
    label: "Tempo no status",
    sortable: false,
    data: (p: ProcessViewModel) => formatSince(p.statusSince) ?? "—",
    index: "statusSince",
    editable: false,
    type: "text" as const,
    width: "120px",
  },
  {
    label: "Incoterm",
    sortable: true,
    data: (p: ProcessViewModel) => p.incoterm,
    index: "incoterm",
    editable: true,
    type: "select" as const,
    options: incotermOptions,
    width: "120px",
  },
  {
    label: "Modo de Importação",
    sortable: true,
    data: (p: ProcessViewModel) => p.importMode,
    index: "importMode",
    editable: true,
    type: "select" as const,
    options: [
      { label: "Encomenda", value: "Encomenda" },
      { label: "Distribuição", value: "Distribuição" },
      { label: "Conta e Ordem", value: "Conta e Ordem" },
    ],
  },
  {
    label: "Exportador",
    sortable: true,
    data: (p: ProcessViewModel) => p.exporter,
    index: "exporter",
    editable: true,
    type: "text" as const,
  },
  {
    label: "Total Invoice",
    data: (p: ProcessViewModel) => p.totalInvoice,
    index: "totalInvoice",
    editable: true,
    type: "currency" as const,
    width: "150px",
  },
  {
    label: "Data Abertura",
    sortable: true,
    data: (p: ProcessViewModel) =>
      p.openingDate
        ? DateTime.fromISO(p.openingDate).toFormat("dd/LL/yyyy")
        : "",
    index: "openingDate",
    editable: true,
    type: "date" as const,
    width: "140px",
  },
  {
    label: "Data Embarque",
    sortable: true,
    data: (p: ProcessViewModel) =>
      p.shippingDate
        ? DateTime.fromISO(p.shippingDate).toFormat("dd/LL/yyyy")
        : "",
    index: "shippingDate",
    editable: true,
    type: "date" as const,
    width: "140px",
  },
  {
    label: "Data Chegada",
    sortable: true,
    data: (p: ProcessViewModel) =>
      p.arrivalDate
        ? DateTime.fromISO(p.arrivalDate).toFormat("dd/LL/yyyy")
        : "",
    index: "arrivalDate",
    editable: true,
    type: "date" as const,
    width: "140px",
  },
  {
    label: "Frete internacional",
    data: (p: ProcessViewModel) => p.internationalFreight,
    index: "internationalFreight",
    editable: true,
    type: "text" as const,
  },
  {
    label: "CE Mercante",
    sortable: true,
    data: (p: ProcessViewModel) => p.ceMerchant,
    index: "condition",

    editable: true,
    type: "text" as const,
  },
  {
    label: "Forma de pagamento",
    sortable: true,
    data: (p: ProcessViewModel) => p.condition,
    index: "condition",
  },
  {
    label: "Número da invoice",
    sortable: true,
    data: (p: ProcessViewModel) => p.invoice,
    index: "invoice",
  },
  {
    label: "LI",
    sortable: true,
    data: (p: ProcessViewModel) => p.li,
    index: "li",

    editable: true,
    type: "text" as const,
  },
  {
    label: "BL/AWB",
    sortable: true,
    data: (p: ProcessViewModel) => p.blAwbCrt,
    index: "blAwbCrt",
    editable: true,
    type: "text" as const,
  },

  {
    label: "Nº Container",
    sortable: true,
    data: (p: ProcessViewModel) => p.containerNumber,
    index: "containerNumber",

    editable: true,
    type: "text" as const,
  },
  {
    label: "Qtde. de Containers",
    sortable: true,
    data: (p: ProcessViewModel) => p.containerQuantity,
    index: "containerQuantity",

    editable: true,
    type: "text" as const,
  },
  {
    label: "Embarcação",
    sortable: true,
    data: (p: ProcessViewModel) => p.vessel,
    index: "vessel",

    editable: true,
    type: "text" as const,
  },
  {
    label: "Canal",
    sortable: true,
    data: (p: ProcessViewModel) => p.channel,
    index: "channel",
    editable: true,
    type: "select" as const,
    options: [
      { label: "Verde", value: "VERDE" },
      { label: "Amarelo", value: "AMARELO" },
      { label: "Vermelho", value: "VERMELHO" },
      { label: "Cinza", value: "CINZA" },
    ],
    width: "120px",
  },
  {
    label: "Vistoria",
    sortable: true,
    data: (p: ProcessViewModel) => p.inspection,
    index: "inspection",
    editable: true,
    type: "text" as const,
  },
  {
    label: "Observação do canal",
    sortable: true,
    data: (p: ProcessViewModel) => p.channelObservation,
    index: "channelObservation",
    editable: true,
    type: "text" as const,
  },
  {
    label: "DI",
    sortable: true,
    data: (p: ProcessViewModel) => p.di,
    index: "di",

    editable: true,
    type: "text" as const,
  },
  {
    label: "Data Registro",
    sortable: true,
    data: (p: ProcessViewModel) =>
      p.registrationDate
        ? DateTime.fromISO(p.registrationDate).toFormat("dd/LL/yyyy")
        : "",
    index: "registrationDate",

    editable: true,
    type: "date" as const,
    width: "140px",
  },
  {
    label: "Data do Desembaraço",
    sortable: true,
    data: (p: ProcessViewModel) =>
      p.customsClearanceDate
        ? DateTime.fromISO(p.customsClearanceDate).toFormat("dd/LL/yyyy")
        : "",
    index: "customsClearanceDate",

    editable: true,
    type: "date" as const,
    width: "140px",
  },
  {
    label: "Agente de Cargas",
    sortable: true,
    data: (p: ProcessViewModel) => p.carrier,
    index: "carrier",

    editable: true,
    type: "text" as const,
  },
  {
    label: "Armador",
    sortable: true,
    data: (p: ProcessViewModel) => p.customsAgent,
    index: "customsAgent",
    editable: true,
    type: "text" as const,
  },
  {
    label: "Local de Origem",
    sortable: true,
    data: (p: ProcessViewModel) => p.countryOfOrigin,
    index: "countryOfOrigin",
    editable: true,
    type: "text" as const,
  },
  {
    label: "Local de Destino",
    sortable: true,
    data: (p: ProcessViewModel) => p.dischargePort,
    index: "dischargePort",

    editable: true,
    type: "text" as const,
  },
  {
    label: "Demurrage",
    sortable: true,
    data: (p: ProcessViewModel) => p.demurrage,
    index: "demurrage",
    editable: true,
    type: "text" as const,
  },
  {
    label: "Data Emissão da NF",
    sortable: true,
    data: (p: ProcessViewModel) => p.nfIssued,
    index: "nfIssued",
    editable: true,
    type: "date" as const,
    width: "140px",
  },
  {
    label: "NCM",
    sortable: true,
    data: (p: ProcessViewModel) => p.ncm,
    index: "ncm",
    editable: true,
    type: "text" as const,
  },
  {
    label: "Situação dos Câmbioss",
    sortable: true,
    data: (p: ProcessViewModel) => p.paymentStatus,
    index: "paymentStatus",
  },
  {
    label: "Moeda invoice",
    sortable: true,
    data: (p: ProcessViewModel) => p.currency,
    index: "currency",
  },
  {
    label: "Free Time",
    sortable: true,
    data: (p: ProcessViewModel) => p.freeTime,
    index: "freeTime",
  },
  {
    label: "Cotação Internacional",
    sortable: true,
    data: (p: ProcessViewModel) => p.internationalQuote,
    index: "internationalQuote",
    editable: true,
    type: "text" as const,
  },
  {
    label: "Cotação Rodoviária",
    sortable: true,
    data: (p: ProcessViewModel) => p.roadQuote,
    index: "roadQuote",
    editable: true,
    type: "text" as const,
  },
  {
    label: "Seguro",
    sortable: true,
    data: (p: ProcessViewModel) => p.insurance,
    index: "insurance",
    editable: true,
    type: "text" as const,
  },
  {
    label: "ICMS",
    sortable: true,
    data: (p: ProcessViewModel) => p.icms,
    index: "icms",
    editable: true,
    type: "text" as const,
  },
  {
    label: "Numerário",
    sortable: true,
    data: (p: ProcessViewModel) => p.cashAmount,
    index: "cashAmount",
    editable: true,
    type: "text" as const,
  },
  {
    label: "Documentos",
    sortable: true,
    data: (p: ProcessViewModel) => p.documents,
    index: "documents",
    editable: true,
    type: "text" as const,
  },
  {
    label: "Catálogo PU",
    sortable: true,
    data: (p: ProcessViewModel) => p.catalogPu,
    index: "catalogPu",
    editable: true,
    type: "text" as const,
  },
  {
    label: "Status LI",
    sortable: true,
    data: (p: ProcessViewModel) => p.liStatus,
    index: "liStatus",
    editable: true,
    type: "text" as const,
  },
  {
    label: "Segmento",
    sortable: true,
    data: (p: ProcessViewModel) => p.segment,
    index: "segment",
    editable: true,
    type: "text" as const,
  },
];
